import { NavItemType } from 'types';

export type NavItemWithPermissions = Omit<NavItemType, 'children' | 'elements'> & {
  permissions?: string[];
  permissionMode?: 'all' | 'any';
  roles?: string[];
  children?: NavItemWithPermissions[];
  elements?: NavItemWithPermissions[];
};

type PermissionMode = 'all' | 'any';
type CheckPermission = (permissions: string | string[], mode?: PermissionMode) => boolean;
type CheckRole = (roles: string[]) => boolean;

export function NavItemWithPermissionsToNavItem(item: NavItemWithPermissions, check: CheckPermission, checkRole?: CheckRole): NavItemType | null {
  const { permissions, permissionMode = 'all', roles, children, elements, ...rest } = item;

  if (permissions?.length && !check(permissions, permissionMode)) {
    return null;
  }

  if (roles?.length && !checkRole?.(roles)) {
    return null;
  }

  const mappedChildren = children
    ?.map((child) => NavItemWithPermissionsToNavItem(child, check, checkRole))
    .filter((child): child is NavItemType => child !== null);

  const mappedElements = elements
    ?.map((element) => NavItemWithPermissionsToNavItem(element, check, checkRole))
    .filter((element): element is NavItemType => element !== null);

  if ((rest.type === 'group' || rest.type === 'collapse') && (!mappedChildren || mappedChildren.length === 0)) {
    return null;
  }

  return {
    ...rest,
    ...(mappedChildren ? { children: mappedChildren } : {}),
    ...(mappedElements ? { elements: mappedElements } : {})
  };
}
